import { render, staticRenderFns } from "./DataPlaceholder.vue?vue&type=template&id=e672abf4&scoped=true&"
import script from "./DataPlaceholder.vue?vue&type=script&lang=js&"
export * from "./DataPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e672abf4",
  null
  
)

export default component.exports